import { PortfolioPlanId, } from "../../Types";
import { makeHook } from "../../utils/makeSingleArgHook";
import { getPortfolioPlanAssignments, portfolioAssignmentsURL, } from "../request/getPortfolioPlanAssignments";
export { PortfolioPlanId, };
export function assignmentsKeyMaker(requestParams) {
    if (requestParams.queryString === undefined) {
        return [portfolioAssignmentsURL(requestParams.abstractPortfolioId, null)];
    }
    return [
        portfolioAssignmentsURL(requestParams.abstractPortfolioId, null),
        portfolioAssignmentsURL(requestParams.abstractPortfolioId, requestParams.queryString),
    ];
}
const useGetPortfolioPlanAssignments = makeHook(getPortfolioPlanAssignments, assignmentsKeyMaker);
export default useGetPortfolioPlanAssignments;
//# sourceMappingURL=usePortfolioPlanAssignments.js.map